import React from 'react';
import { useSpring, animated } from 'react-spring';

import { Info, AlertCircle, CheckCircle } from 'react-feather';

import './NotificationBox.css';

const NotificationBox = ({ windowSize, show, title, text, type }) => {

  const boxProps = useSpring({ opacity: show ? 1 : 0, right: show ? "30px" : "-400px" , borderBottomColor: type === "error" ? '#dc3545' : type === "success" ? '#28a745' : '#007bff'});
  const color = {color: type === "error" ? '#dc3545' : type === "success" ? '#28a745' : '#007bff'};

  return (
    <animated.div style={boxProps} className="notificationBox">
      <div className='notificationWrap'>

      { type === 'info'
      ? <Info className="notificationIcon" style={color} />
      : type === 'error'
      ? <AlertCircle className="notificationIcon" style={color} />
      : <CheckCircle className="notificationIcon" style={color}/>
      }
      <div className="notificationInfo">
        <p className="notificationTitle" style={color}>{title}</p>
        <p className="notificationText" style={color}>{text}</p>
      </div>
    </div>

      {/* <div className='notificationLoading'></div> */}
    </animated.div>
  );
}

export { NotificationBox };